import { IPROP_MAP } from '../../generators/modifyProps';
import { JDSButtonProps } from './generated';
import { formatIconName } from '../jdsicon/logic';
import { forwardRef } from 'react';

export interface ButtonProps extends JDSButtonProps {
  /**
   * @deprecated
   * Use `label` instead
   */
  title?: string;
  /**
   * @deprecated
   * Use `label` instead
   */
  children?: React.ReactNode;
  className?: string;
}

export const PROP_MAP: IPROP_MAP<ButtonProps> = (props) => ({
  children: {
    properties: {
      label: props.children
    }
  },
  title: {
    properties: {
      label: props?.title
    }
  },
  label: {
    properties: {
      label: props.label
    }
  }
});

export const withLogic = (
  Component: React.ComponentType<ButtonProps>
): React.FC<ButtonProps> =>
  forwardRef((props: ButtonProps, ref) => {
    const hasLabel = Boolean(props.children || props.title || props.label);

    if (props.children) {
      console.warn('children prop is deprecated. Use label instead');
    }

    return (
      <Component
        {...{
          ...props,
          rootRef: ref,
          label: props.children || props.label || props.title,
          _hasRightIcon: Boolean(props.icon),
          _hasLabel: hasLabel,
          iconAriaLabel:
            props.iconAriaLabel || formatIconName(props.icon as string)
        }}
      />
    );
  });
